export enum RIGHTSIDECOMPONENTS {
  NONE = 'NONE',
  SHAPES = 'SHAPES',
  FILTERS = 'FILTERS',
  REPORTS = 'REPORTS',
  EVENTS = 'EVENTS',
  ATONS = 'ATONS',
  MESSAGES = 'MESSAGES',
}

export enum ACTIVETAB {
  NONE = 'NONE',
  SHAPES = 'SHAPES',
  FILTERS = 'FILTERS',
  REPORTS = 'REPORTS',
  EVENTS = 'EVENTS',
  REPLAY = 'REPLAY',
  ATONS = 'ATONS',
  MESSAGES = 'MESSAGES',
}
